export const SET_CLINICS = 'SET_CLINICS';
export const SET_GRABSCAN_CLINICS = 'SET_GRABSCAN_CLINICS';
export const SET_SELECTED_CLINIC = 'SET_SELECTED_CLINIC';
